import { render, staticRenderFns } from "./NewProjectPublicationTab.vue?vue&type=template&id=d32771bc&"
import script from "./NewProjectPublicationTab.vue?vue&type=script&lang=js&"
export * from "./NewProjectPublicationTab.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectPublicationTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports